import { useState, useEffect, useCallback } from 'react';
import logger from 'ws-scripts/modules/logger';
import { usePubsub } from 'wsm-lsp-utilities';

const LOG_PREFIX = '[ws-locations-filters][useLocationsMakeFilter]';
const FILTER_TOPIC = 'ws-locations-data/filtered-locations';

/**
 * Hook to integrate with ws-locations-data widget.
 * Uses the global window.DDC.LocationsData API to:
 * 1. Listen for LocationsData availability via custom event
 * 2. Subscribe to filter change updates via FILTER_TOPIC
 */
export const useLocationsMakeFilter = (isReady) => {
	const [makeFilters, setMakeFilters] = useState([]);

	const handleFilterChange = useCallback(() => {
		const LOCATIONS_DATA = window.DDC?.LocationsData;
		if (LOCATIONS_DATA?.getActiveMakes) {
			const makes = LOCATIONS_DATA.getActiveMakes();
			setMakeFilters(makes);
		}
	}, []);

	// Load initial data when ready
	useEffect(() => {
		if (!isReady) {
			logger.debug(`${LOG_PREFIX} Not subscribing - isReady: ${isReady}`);
			return;
		}
		handleFilterChange();
	}, [isReady, handleFilterChange]);

	// Subscribe to updates
	usePubsub(FILTER_TOPIC, handleFilterChange, { isReady });

	const removeMakeFilter = useCallback((id) => {
		setMakeFilters((prev) => {
			if (!prev.includes(id)) {
				return prev;
			}
			const updatedMakes = prev.filter((makeId) => makeId !== id);
			window.DDC.LocationsData.setFilters({
				makes: updatedMakes
			});
			return updatedMakes;
		});
	}, []);

	const resetMakeFilters = () => {
		if (
			makeFilters.length > 0 &&
			window.DDC?.LocationsData?.resetMakeFilter
		) {
			setMakeFilters([]);
			window.DDC.LocationsData.resetMakeFilter();
		}
	};

	return {
		makeFilters,
		removeMakeFilter,
		resetMakeFilters
	};
};
